import { fetchRequest } from '$CONFIG/Fatch.config';
import { ApiPort } from '$ACTIONS/API';

export const CaptchaIsEnable = (username) => {
    return fetchRequest(`${ApiPort.CaptchaInfo}?username=${username}`, 'GET')
        .then(res => {
            if (res?.isSuccess && res?.result) {
                return res.result.isEnabled;
            }
            return true; // 如果 API 失敗，預設啟用 captcha
        }).catch(error => {
            console.log('Captcha service check failed:', error);
            return true; // 如果 API 失敗，預設啟用 captcha
        });
}